export const ADMIN_ROLE = 'ADMIN';

export function isAdmin(role?: string): boolean {
  return role?.toUpperCase() === ADMIN_ROLE;
}
